import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { MinutesProps } from '../../services/requests/ata/types';

export type MinuteState = {
  minute: MinutesProps;
  reload: boolean;
  selectedMinute: Partial<MinutesProps> | null;
  setSelectedMinutes: (minutes: MinutesProps) => void;
  setMinute: (minutes: MinutesProps) => void;
  setReload: (type: boolean) => void;
};

const useMinuteStore = create(
  persist<MinuteState>(
    set =>
      ({
        minute: {},
        selectedMinute: null,
        reload: false,
        setSelectedMinute: (minute: MinutesProps) =>
          set({
            selectedMinute: minute,
          }),
        setReload: (type: boolean) =>
          set({
            reload: type,
          }),

        setMinute: (minute: MinutesProps) =>
          set({
            minute,
          }),
      } as unknown as MinuteState),
    {
      name: '@tenGovUseMinuteStore',
    },
  ),
);
export default useMinuteStore;
